// Import: Middleware Action & Custom Types
import { CLEAN_PUT_LEAD, CLEAN_PUT_LEAD_ERROR } from "_models/redux/types";

// Action function
export const cleanPutLeadAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_PUT_LEAD,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_PUT_LEAD_ERROR,
            payload: undefined,
        });
    }
};
